module.exports = __webpack_public_path__ + "static/media/zara.a1f5b2b1.svg";